import React from "react";
import FilterSelect, {
  FilterSelectOption,
} from "../../../components/reusable-components/UI/FilterSelect";
import { AutocompleteProps } from "@mui/material/Autocomplete";
import { useStoredDomain } from "../hooks/useStoredDomain";

type DomainFilterSelectProps = {
  value: string;
  onChange: (value: string) => void;
  inputValue: string;
  onInputChange: (val: string) => void;
  options: FilterSelectOption[];
  label?: string;
  placeholder?: string;
} & Omit<
  AutocompleteProps<FilterSelectOption, false, false, false>,
  | "value"
  | "onChange"
  | "inputValue"
  | "onInputChange"
  | "options"
  | "renderInput"
  | "getOptionLabel"
  | "isOptionEqualToValue"
  | "filterOptions"
>;

const DomainFilterSelect: React.FC<DomainFilterSelectProps> = ({
  value,
  onChange,
  inputValue,
  onInputChange,
  options,
  loading,
  label = "Filter by Domain",
  placeholder = "Search domain...",
  ...rest
}) => {
  const selectedDomain = useStoredDomain();

  return (
    <FilterSelect
      value={value}
      onChange={onChange}
      inputValue={selectedDomain ? options[0].label : inputValue}
      onInputChange={onInputChange}
      options={options}
      loading={loading}
      label={label}
      fullWidth
      placeholder={placeholder}
      {...rest}
      disabled={!!selectedDomain || rest.disabled}
    />
  );
};

export default DomainFilterSelect;
